import * as stampsAPI from "./stamps-api";

export async function getStamps(params = {}) {
  try {
    const data = await stampsAPI.index(params);
    return data;
  } catch (err) {
    return err;
  }
}

export async function getFilterOptions() {
  try {
    const data = await stampsAPI.filterOptions();
    return data;
  } catch (err) {
    return err;
  }
}

export async function getHiddenStamps(params = {}) {
  try {
    const data = await stampsAPI.hiddenIndex(params);
    return data;
  } catch (err) {
    return err;
  }
}

export async function createStamp(newCaseData) {
  try {
    const data = await stampsAPI.create(newCaseData);
    return data;
  } catch (err) {
    return err;
  }
}

export async function getStamp(id) {
  try {
    const data = await stampsAPI.detail(id);
    return data;
  } catch (err) {
    return err;
  }
}
// export async functionStampsaseSummary(id){
//     try{
//        const data = await stampsAPIStampsaseSummary(id)
//        return data
//     }catch(err){
//         return err
//     }
// }

export async function getMostRecentStamp(id) {
  try {
    const data = await stampsAPI.getMostRecentStamp(id);
    return data;
  } catch (err) {
    return err;
  }
}

export async function deleteStamp(id) {
  try {
    const data = await stampsAPI.destroy(id);
    return data;
  } catch (err) {
    return err;
  }
}

export async function updateStamp(id, stampData) {
  try {
    const data = await stampsAPI.update(id, stampData);
    return data;
  } catch (err) {
    return err;
  }
}

export async function getS3Url(contentType) {
  try {
    const response = await stampsAPI.getS3Url(contentType);
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
}

export async function sendS3Url(url, file) {
  try {
    const response = await stampsAPI.sendS3Url(url, file);
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
}

export async function reorderStamps(updates) {
  try {
    const data = await stampsAPI.reorderBatch(updates);
    return data;
  } catch (err) {
    return err;
  }
}

export async function incrementLike(stampId) {
  try {
    const response = await stampsAPI.incrementLike(stampId);
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
}
